var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, memo, useEffect, useState, useRef } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import ScrollView from '@hfe/max-scrollview';
// import LText from '@max/leez-text';
import Card from './Card';
import Icon from '@max/leez-icon';
import './index.scss';
import Image from '@hfe/max-image';
import fetchData from './api';
import { LOAD_MORE_TYPE } from './types';
import { DYNAMIC_LIST_SCENE_TOKEN, LX_CONFIG, SHOW_TYPE_ENUM } from './constants';
import Sensor from '@max/mbc-sensor';
import Skeleton from './Skeleton';
import LoadingView from '@max/leez-loading-view';
import { useUserInfo } from './common-api/use-user';
import { useLocation } from './hooks/useLocation';
import { getLBSInfo } from '@nibfe/mkt-lbs-api';
import { getCityInfo } from '@max/meituan-uni-city';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { debounce, onGoFilter } from './utils';
const DEV_DATA = {
    batchId: '1794167826',
    poiTagId: 670909,
    uuid: 237
};
// 定义城市来源
var CityIdSource;
(function (CityIdSource) {
    CityIdSource["ALL"] = "all";
    // 全国展示
    CityIdSource["LINK"] = "link";
    // 从链接获取城市id
    CityIdSource["LOCATION"] = "location";
    // 从用户定位获取城市id
    CityIdSource["HOME"] = "home";
    // 从用户首页获取城市id
    CityIdSource["DEFAULT"] = "default";
    // 以默认城市初始化请求
    CityIdSource["CITY_FILTER_CHANGE"] = "city_filter_change"; // 城市筛选变化
})(CityIdSource || (CityIdSource = {}));
const DEFAULT_CITY_ID = 1;
const PhxPoiList = (props) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { userInfo } = useUserInfo();
    const { location, locationDone } = useLocation(DYNAMIC_LIST_SCENE_TOKEN);
    const { tagIds, sortType, pageSize = 10, showType, 
    // showMoreJumpLink,
    loadMoreType = LOAD_MORE_TYPE.LINK, 
    //后端不支持分页，暂时固定为link
    fullRoomBase, marginTop, marginBottom, noDataText, noDataTextColor, noDataBackgroundColor, noDataImg, 
    // noDataJumpLink,
    clickBizLine, loadMoreForceLogin, wakeupSource: rawWakeupSource = 'default', defaultPost = true, 
    // 是否采用默认城市初始化请求
    isGetCityFromLocation = false, 
    // 是否优先展示用户定位城市
    isGetCityFromLink = false, 
    // 是否自动从链接获取房源城市
    isAllCityShow = false // 是否全国展示
     } = props;
    // 为wakeupSource添加前缀
    const wakeupSource = rawWakeupSource.startsWith('waitou_') ? rawWakeupSource : `waitou_${rawWakeupSource}`;
    const userId = useRef('');
    const userUuid = useRef('');
    const offset = useRef(0);
    // const { uuid, poiTagId } = poiDataInfo ?? {};
    const tagIdArr = props.isGetCityFromLink ? [] : tagIds === null || tagIds === void 0 ? void 0 : tagIds.split(',').reduce((acc, item) => {
        const num = Number(item);
        if (!isNaN(num)) {
            acc.push(num);
        }
        return acc;
    }, []);
    const ctx = useMonitorEngineContext();
    // const ctx = useContext<BusinessCommonEngineInject>(global._EngineGlobalContext);
    // 优先走跳链上拼接的cityId
    // const cityId = useRef(ctx?._runtimeInfo?.queryParams?.cityId ?? DEFAULT_CITY_ID);
    const chosenCityId = useRef((_c = (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.queryParams) === null || _b === void 0 ? void 0 : _b.cityId) !== null && _c !== void 0 ? _c : DEFAULT_CITY_ID);
    const chosenCityInfo = useRef(null);
    const { userId: comUserId, token: comToken } = ((_d = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _d === void 0 ? void 0 : _d.commonParams) || {}; // NOTE:建议用户信息和城市id都从commonParams中获取
    const { _LXReport, _moduleId } = ctx;
    // const [phxList, setPhxList] = useState([]);
    const phxList = useRef([]);
    const [displayList, setDisplayList] = useState([]);
    const [noMore, setNoMore] = useState(false);
    const [showSkeleton, setShowSkeleton] = useState(false);
    const [showNoDataView, setShowNoDataView] = useState(false);
    const [showLoading, setShowLoading] = useState(false);
    const isConfigCity = defaultPost || isAllCityShow || isGetCityFromLink || isGetCityFromLocation;
    const isSupportCityChange = useRef(!isConfigCity); // 如果配置了城市等配置，那么初始化请求，则不需要等待cityChange事件
    const hotelchannel = (_f = (_e = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _e === void 0 ? void 0 : _e.queryParams) === null || _f === void 0 ? void 0 : _f.hotelchannel;
    const queryRef = useRef("");
    const getFrontListVo = (backendProductList) => {
        const { buyButtonText, headIcon, headIconImg, headIconText, headIconTextColor, headIconBackgroundColor, scoreInfoSwitch, distanceInfoSwitch, salesInfoSwitch, bookInfoSwitch, priceColor, buyButtonTextColor, buyButtonBackgroundColor } = props;
        const result = [];
        if (!(backendProductList && (backendProductList === null || backendProductList === void 0 ? void 0 : backendProductList.length))) {
            return [];
        }
        backendProductList.forEach(backendProduct => {
            var _a;
            const { productId, productIdStr, headImage, title, positionInfo, priceModel, status, rating, userReview, score, salesCount, extModel, bookInfo, hoursInfoDesc, perCapita, imageList } = backendProduct;
            const phxListCard = {
                productId,
                productIdStr,
                headImage: {
                    value: headImage
                },
                title,
                positionInfo: (_a = positionInfo === null || positionInfo === void 0 ? void 0 : positionInfo[0]) !== null && _a !== void 0 ? _a : '',
                price: priceModel,
                status,
                buyButtonText,
                salesCount,
                score,
                rating,
                userReview: userReview[0] ? `“${userReview[0]}”` : '',
                headIcon,
                headIconImg,
                headIconText,
                headIconTextColor,
                headIconBackgroundColor,
                extModel,
                bookInfo,
                scoreInfoSwitch,
                distanceInfoSwitch,
                salesInfoSwitch,
                bookInfoSwitch,
                priceColor,
                buyButtonTextColor,
                buyButtonBackgroundColor,
                hoursInfoDesc,
                averagePrice: perCapita,
                imageList
            };
            result.push(phxListCard);
        });
        return result;
    };
    const setDisplayPoiList = (isRefresh = false) => {
        const finalList = phxList.current;
        const startIndex = offset.current;
        const endIndex = startIndex + pageSize;
        // 1. 先获取要展示的数据
        const finalDisPlayList = finalList.slice(startIndex, Math.min(endIndex, finalList.length));
        // 2. 如果有数据才更新
        if (finalDisPlayList.length > 0) {
            if (isRefresh) {
                setDisplayList(finalDisPlayList);
            }
            else {
                setDisplayList(prev => [...prev, ...finalDisPlayList]);
            }
            offset.current = endIndex;
        }
        // 3. 判断是否还有更多数据
        const isNoMore = finalList.length <= endIndex;
        setNoMore(isNoMore);
    };
    const getPoiList = (refresh = false) => __awaiter(void 0, void 0, void 0, function* () {
        var _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        console.log('getPoiList: ', chosenCityInfo.current);
        //const { dateBegin, dateEnd } = getDate();
        const reqData = Object.assign(Object.assign({ uuid: userUuid.current || '', userId: comUserId, dynamicTagId: tagIdArr, fullPoiFormat: fullRoomBase, 
            // poiTagUuid: uuid,
            // offset: offset.current,
            // limit: pageSize,
            sort: sortType, sortWithPrivilegePoi: props === null || props === void 0 ? void 0 : props.sortWithPrivilegePoi, 
            // hotelChannel: ctx?._runtimeInfo?.queryParams?.hotelchannel,
            userLongitude: ((_h = chosenCityInfo.current) === null || _h === void 0 ? void 0 : _h.source) === CityIdSource.LINK ? undefined : location === null || location === void 0 ? void 0 : location.lng, userLatitude: ((_j = chosenCityInfo.current) === null || _j === void 0 ? void 0 : _j.source) === CityIdSource.LINK ? undefined : location === null || location === void 0 ? void 0 : location.lat, chosenCityId: chosenCityId.current }, (queryRef.current && queryRef.current !== "" ? {
            query: queryRef.current
        } : {})), { token: comToken, locateCityId: DEFAULT_CITY_ID //本地默认
         });
        try {
            //本地跨越获取不到
            const cityInfo = yield getCityInfo();
            reqData.locateCityId = (cityInfo === null || cityInfo === void 0 ? void 0 : cityInfo.id) || DEFAULT_CITY_ID;
        }
        catch (e) {
            console.log('getCityInfo error: ', e);
        }
        // 预览态，需要注意
        if (window === null || window === void 0 ? void 0 : window.inEditor) {
            reqData.previewId = '1';
        }
        try {
            if (!refresh) {
                setShowLoading(true);
            }
            setShowNoDataView(false);
            const params = {
            // userId: userId.current,
            // userid: userId.current,
            // utm_medium: systemType === SystemType.android ? 'android' : 'iphone',
            // uuid: userUuid.current,
            // utm_content: userUuid.current,
            // isPtest: true, // ptest环境测试，上线前需注释掉
            };
            // console.log('params before fetchData: ', ctx?._runtimeInfo, params);
            console.log('minsu reqData before fetchData: ', reqData);
            const { productInfoList = [] } = yield fetchData(reqData, params, wakeupSource, () => { var _a, _b; return (_b = (_a = ctx._raptorReport).monitorReportNetworkSuccess) === null || _b === void 0 ? void 0 : _b.call(_a); }, () => { var _a, _b; return (_b = (_a = ctx._raptorReport).monitorReportNetworkFailed) === null || _b === void 0 ? void 0 : _b.call(_a); });
            if (Array.isArray(productInfoList)) {
                // 业务成功了，我拿到了想要的数据
                (_l = (_k = ctx._raptorReport).monitorReportBizSuccess) === null || _l === void 0 ? void 0 : _l.call(_k);
                if (productInfoList.length) {
                    // 货架没有空搜
                    (_o = (_m = ctx._raptorReport).monitorReportShelfNormal) === null || _o === void 0 ? void 0 : _o.call(_m);
                }
                else {
                    // 货架空搜
                    (_q = (_p = ctx._raptorReport).monitorReportShelfEmpty) === null || _q === void 0 ? void 0 : _q.call(_p, {
                        city_id: reqData.locateCityId
                    });
                }
            }
            else {
                // 业务失败了
                (_s = (_r = ctx._raptorReport).monitorReportBizFailed) === null || _s === void 0 ? void 0 : _s.call(_r, {
                    city_id: reqData.locateCityId
                });
            }
            const frontList = getFrontListVo(productInfoList);
            // 初始化就无货时，认为该城市无货，走兜底逻辑
            if ((frontList === null || frontList === void 0 ? void 0 : frontList.length) === 0) {
                setShowNoDataView(true);
            }
            phxList.current = frontList;
            setDisplayPoiList(refresh);
        }
        catch (error) {
            ctx._uiInteractionAPI.toast.show({
                content: '活动太火爆啦～'
            });
        }
        setShowSkeleton(false);
        setShowLoading(false);
    });
    const init = () => __awaiter(void 0, void 0, void 0, function* () {
        // if (!poiTagId || !uuid) {
        // 仅在未勾选「是否自动从链接获取房源城市」且没有tagId时，跳过初始化
        if (!props.isGetCityFromLink && !(tagIdArr === null || tagIdArr === void 0 ? void 0 : tagIdArr.length)) {
            return;
        }
        offset.current = 0;
        setShowSkeleton(true);
        phxList.current = [];
        yield getPoiList(true);
    });
    // const loadMore = async () => {
    //   if ((!userId.current || !userUuid.current) && !loadMoreForceLogin) {
    //     console.log("分支1");
    //     console.log('userUuid.current: ', userUuid.current);
    //     console.log('userId.current: ', userId.current);
    //     const res = await login();
    //     if (res?.userId) {
    //       const userInfoAfterLogin = await getUserInfo();
    //       console.log('userInfoAfterLogin: ', userInfoAfterLogin);
    //       const { userId: originalUserId, uuid: user_uuid } = userInfoAfterLogin ?? {};
    //       if (originalUserId) {
    //         userId.current = originalUserId;
    //         userUuid.current = user_uuid;
    //         init();
    //       }
    //     } else {
    //       setTimeout(() => {
    //         navigateBack({
    //           _web: {
    //             miniProgramNative: true, //说明：此参数只在web端生效。1）如果在小程序/点评&美团APP中，为ture的话会调用native的方法，也就是直接关闭这个页面，为fase或不传在当前webview中返回。
    //           },
    //         });
    //       }, 500);
    //     }
    //   } else {
    //     if (loadMoreType === LOAD_MORE_TYPE.LINK) {
    //       console.log("分支2-1");
    //      onGoFilter({cityId:chosenCityId.current,clickBizLine,hotelchannel});
    //     } else {
    //       console.log("分支2-2");
    //       getPoiList();
    //     }
    //   }
    // };
    const loadMore = (moreType) => {
        const finalLoadMoreType = moreType !== null && moreType !== void 0 ? moreType : loadMoreType;
        if (finalLoadMoreType === LOAD_MORE_TYPE.LINK) {
            onGoFilter({
                cityId: chosenCityId.current,
                clickBizLine,
                hotelchannel,
                wakeupSource,
                queryString: queryRef.current && queryRef.current !== "" ? queryRef.current : undefined
            });
            return;
        }
        setDisplayPoiList();
    };
    // 从链接获取城市id
    const getLinkCity = () => {
        var _a, _b;
        let cityId = null;
        try {
            cityId = Number((_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.queryParams) === null || _b === void 0 ? void 0 : _b.cityId);
        }
        catch (error) {
            console.log('getLinkCityId error: ', error);
        }
        return cityId ? {
            cityId: Number(cityId),
            source: CityIdSource.LINK
        } : null;
    };
    // 获取用户定位城市
    const getUserLocationCity = () => __awaiter(void 0, void 0, void 0, function* () {
        let cityId = null;
        try {
            const cityInfo = yield getCityInfo();
            cityId = cityInfo === null || cityInfo === void 0 ? void 0 : cityInfo.id;
        }
        catch (error) {
            console.log('getUserLocationCity error: ', error);
        }
        return cityId ? {
            cityId,
            source: CityIdSource.LOCATION
        } : null;
    });
    // 获取用户首页城市
    const getUserHomeCity = () => __awaiter(void 0, void 0, void 0, function* () {
        let cityId = null;
        try {
            const locationInfo = yield getLBSInfo({
                needLocation: true,
                sceneToken: 'dd-9cbc1c31cfbf2bba'
            });
            cityId = locationInfo === null || locationInfo === void 0 ? void 0 : locationInfo.homeSelectedCity;
        }
        catch (error) {
            console.log('getUserHomeCity error: ', error);
        }
        return cityId ? {
            cityId,
            source: CityIdSource.HOME
        } : null;
    });
    // 获取默认城市id
    const getDefaultCity = () => {
        return {
            cityId: DEFAULT_CITY_ID,
            source: CityIdSource.DEFAULT
        };
    };
    // 获取全国展示城市id
    const getAllCity = () => {
        return {
            cityId: 0,
            source: CityIdSource.ALL
        };
    };
    // 获取城市id
    const getChosenCityInfo = () => __awaiter(void 0, void 0, void 0, function* () {
        // 勾选「是否全国展示」
        if (isAllCityShow) {
            return getAllCity();
        }
        const linkCity = getLinkCity();
        const userLocationCity = yield getUserLocationCity();
        const userHomeCity = yield getUserHomeCity();
        const defaultCityId = getDefaultCity();
        // 勾选「是否优先从链接获取房源城市」
        if (isGetCityFromLink && linkCity) {
            return linkCity;
        }
        // 勾选「优先展示用户定位城市」
        if (isGetCityFromLocation) {
            if (userLocationCity) {
                return userLocationCity;
            }
            if (userHomeCity) {
                return userHomeCity;
            }
            return defaultCityId;
        }
        // 勾选「是否以默认城市初始化请求」时，默认展示首页城市
        if (defaultPost) {
            if (userHomeCity) {
                return userHomeCity;
            }
            return defaultCityId;
        }
        return defaultCityId;
    });
    // 设置userId和userUuid
    const setUserIdAndUserUuid = () => {
        const { userId: originalUserId, uuid: user_uuid } = userInfo !== null && userInfo !== void 0 ? userInfo : {};
        console.log('userInfo=====: ', userInfo);
        if (originalUserId) {
            userId.current = originalUserId;
            userUuid.current = user_uuid;
        }
    };
    useEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b, _c;
            if (userInfo.done && locationDone) {
                setUserIdAndUserUuid();
                if (isConfigCity) {
                    console.log('配置了城市: ', isConfigCity);
                    chosenCityInfo.current = yield getChosenCityInfo();
                    chosenCityId.current = (_a = chosenCityInfo.current) === null || _a === void 0 ? void 0 : _a.cityId;
                    yield init();
                    isSupportCityChange.current = true;
                }
                console.log('cube_router_url', decodeURIComponent((_c = (_b = ctx._runtimeInfo) === null || _b === void 0 ? void 0 : _b.queryParams) === null || _c === void 0 ? void 0 : _c['cube_router_url']));
            }
        }))();
    }, [props.defaultPost, props.isAllCityShow, props.isGetCityFromLink, props.isGetCityFromLocation, userInfo.done, locationDone]);
    useEffect(() => {
        if (window === null || window === void 0 ? void 0 : window.inEditor) {
            // 在画布中确保后端已更新数据
            setTimeout(() => {
                init().catch(error => {
                    console.log('init error: ', error);
                });
            }, 2000);
        }
    }, [tagIds]);
    // const onCityChange = useCallback(
    //   (city: { value: string; title: string }) => {
    //     console.log('民宿poi列表，监听到城市变化', city);
    //     if (city?.value) {
    //       console.log('民宿poi列表，监听到城市变化', city);
    //       chosenCityId.current = Number(city.value);
    //       isCityInitialized.current = true;
    //       if (userInfo.done) {
    //         setTimeout(() => {
    //           init();
    //         }, 0);
    //       }
    //     }
    //   },
    //   [userInfo.done],
    // );
    const debouncedInit = debounce(() => {
        init().catch(error => {
            console.log('init error: ', error);
        });
    }, 150);
    const onCityChange = (city) => {
        var _a;
        if ((city === null || city === void 0 ? void 0 : city.value) && isSupportCityChange.current) {
            chosenCityInfo.current = {
                cityId: Number(city.value),
                source: CityIdSource.CITY_FILTER_CHANGE
            };
            chosenCityId.current = (_a = chosenCityInfo.current) === null || _a === void 0 ? void 0 : _a.cityId;
            queryRef.current = "";
            setTimeout(() => {
                debouncedInit();
            }, 0);
        }
    };
    useEffect(() => {
        var _a;
        (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.on('cityChanged', onCityChange);
        return () => {
            var _a;
            (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.off('cityChanged', onCityChange);
        };
    }, []);
    useEffect(() => {
        var _a;
        const onDynamicPoiListSearchParamsChanged = (signal) => {
            var _a;
            const nextCityId = signal === null || signal === void 0 ? void 0 : signal.cityId;
            const shouldRefreshCity = nextCityId && nextCityId !== chosenCityId.current && isSupportCityChange.current;
            if (shouldRefreshCity) {
                chosenCityInfo.current = {
                    cityId: nextCityId,
                    source: CityIdSource.CITY_FILTER_CHANGE
                };
                chosenCityId.current = (_a = chosenCityInfo.current) === null || _a === void 0 ? void 0 : _a.cityId;
                queryRef.current = "";
            }
            const nextLandmarkName = signal === null || signal === void 0 ? void 0 : signal.landmark;
            const shouldRefreshQuery = queryRef.current !== nextLandmarkName;
            if (shouldRefreshQuery) {
                queryRef.current = nextLandmarkName;
            }
            if (shouldRefreshCity || shouldRefreshQuery) {
                debouncedInit();
            }
        };
        (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.on('dynamicPoiListSearchParamsChanged', onDynamicPoiListSearchParamsChanged);
        return () => {
            var _a;
            (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.off('dynamicPoiListSearchParamsChanged', onDynamicPoiListSearchParamsChanged);
        };
    }, []);
    const onComponentShowMV = () => {
        var _a, _b, _c, _d, _e, _f;
        _LXReport === null || _LXReport === void 0 ? void 0 : _LXReport.mvReport(LX_CONFIG.COMP_MV_BID, {
            valLab: {
                _moduleId: _moduleId !== null && _moduleId !== void 0 ? _moduleId : '-999',
                tex_id: (_c = (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.queryParams) === null || _b === void 0 ? void 0 : _b.pageId) !== null && _c !== void 0 ? _c : '-999',
                custom: {
                    click_biz_line: clickBizLine !== null && clickBizLine !== void 0 ? clickBizLine : '-999',
                    hotel_channel: (_f = (_e = (_d = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _d === void 0 ? void 0 : _d.queryParams) === null || _e === void 0 ? void 0 : _e.hotelchannel) !== null && _f !== void 0 ? _f : '-999',
                    wakeupSource
                }
            }
        });
    };
    const jumpToNoDataFallbackPage = () => {
        if (window === null || window === void 0 ? void 0 : window.inEditor) {
            return;
        }
        onGoFilter({
            cityId: chosenCityId.current,
            clickBizLine,
            hotelchannel,
            wakeupSource,
            queryString: queryRef.current && queryRef.current !== "" ? queryRef.current : undefined
        });
    };
    if (showSkeleton) {
        return <Skeleton showType={showType}/>;
    }
    if (showNoDataView) {
        return <View style={{
            backgroundColor: noDataBackgroundColor
        }} className="phx-poi-lis-no-data-container" onClick={() => {
            jumpToNoDataFallbackPage();
        }}>
        <Text style={{
            color: noDataTextColor
        }} className="phx-poi-lis-no-data-text">
          {noDataText}
        </Text>
        <Image style={{
            width: '750rpx'
        }} source={{
            uri: noDataImg
        }}/>
      </View>;
    }
    return <Sensor once onAppear={() => {
        onComponentShowMV();
    }}>
      <View className="phx-poi-lis-container" style={{
        marginTop,
        marginBottom,
        paddingLeft: showType === SHOW_TYPE_ENUM.SIGNAL_ROW ? '12rpx' : '24rpx',
        paddingRight: showType === SHOW_TYPE_ENUM.SIGNAL_ROW ? '12rpx' : '24rpx'
    }}>
        <View x-if={showType === SHOW_TYPE_ENUM.TWO_LIST}>
          <View className="phx-poi-lis-card-wrap">
            {(displayList !== null && displayList !== void 0 ? displayList : []).map((item, index) => {
        var _a, _b;
        return <Card poiInfo={Object.assign({}, item)} style={{
            marginTop: index < 2 ? 0 : '18rpx'
        }} key={(_b = (_a = item.productId) !== null && _a !== void 0 ? _a : item.productIdStr) !== null && _b !== void 0 ? _b : index} clickBizLine={clickBizLine} wakeupSource={wakeupSource}/>;
    })}
          </View>
          <LoadingView x-if={showLoading} level={'medium'} showContent={false} style={{
        marginTop: '20rpx'
    }}/>
          <View x-if={!noMore && loadMoreType === LOAD_MORE_TYPE.BUTTON || loadMoreType === LOAD_MORE_TYPE.LINK} className="phx-poi-lis-show-more-container" onClick={() => loadMore()}>
            <View className="phx-poi-lis-show-more-button">
              <Text className="phx-poi-lis-show-more-text">查看更多</Text>
              <Icon name="jiantouxianxia" color="#555555"/>
            </View>
          </View>
          <Sensor x-if={!noMore && loadMoreType === LOAD_MORE_TYPE.PULL_UP} className="phx-poi-lis-load-more-sensor" onAppear={() => {
        loadMore();
    }}/>
        </View>
        <View x-elseif={showType === SHOW_TYPE_ENUM.SIGNAL_ROW}>
          <ScrollView horizontal={true} showsHorizontalScrollIndicator={false}>
            {((_g = phxList.current) !== null && _g !== void 0 ? _g : []).slice(0, 10).map((item, index) => {
        var _a, _b;
        return <Card poiInfo={Object.assign({}, item)} style={{
            marginRight: '18rpx'
        }} showType={SHOW_TYPE_ENUM.SIGNAL_ROW} key={(_b = (_a = item.productId) !== null && _a !== void 0 ? _a : item.productIdStr) !== null && _b !== void 0 ? _b : index} clickBizLine={clickBizLine} wakeupSource={wakeupSource}/>;
    })}
            <View className="phx-poi-lis-row-type-show-more-button" onClick={() => loadMore(LOAD_MORE_TYPE.LINK)}>
              <View className="phx-poi-lis-row-type-show-more-view">
                {'点击查看更多'.split('').map((char, index) => <Text key={char} className="phx-poi-lis-row-type-show-more-text" style={{
        color: 'white',
        height: '32rpx',
        fontFamily: 'PingFang SC',
        fontWeight: '400',
        fontSize: '24rpx',
        letterSpacing: 0
    }}>
                    {char}
                  </Text>)}
              </View>
            </View>
          </ScrollView>
        </View>
        <View x-elseif={showType === SHOW_TYPE_ENUM.SIGNAL_ROW_BIG_PIC}>
          <View className="phx-poi-lis-card-wrap">
            {(displayList !== null && displayList !== void 0 ? displayList : []).map((item, index) => {
        var _a, _b;
        return <Card poiInfo={Object.assign({}, item)} style={{
            marginTop: index < 2 ? 0 : '18rpx'
        }} showType={SHOW_TYPE_ENUM.SIGNAL_ROW_BIG_PIC} key={(_b = (_a = item.productId) !== null && _a !== void 0 ? _a : item.productIdStr) !== null && _b !== void 0 ? _b : index} clickBizLine={clickBizLine} wakeupSource={wakeupSource}/>;
    })}
          </View>
          <LoadingView x-if={showLoading} level={'medium'} showContent={false} style={{
        marginTop: '20rpx'
    }}/>
          <View x-if={!noMore && loadMoreType === LOAD_MORE_TYPE.BUTTON || loadMoreType === LOAD_MORE_TYPE.LINK} className="phx-poi-lis-show-more-container" onClick={() => loadMore()}>
            <View className="phx-poi-lis-show-more-button">
              <Text className="phx-poi-lis-show-more-text">查看更多</Text>
              <Icon name="jiantouxianxia" color="#555555"/>
            </View>
          </View>
          <Sensor x-if={!noMore && loadMoreType === LOAD_MORE_TYPE.PULL_UP} className="phx-poi-lis-load-more-sensor" onAppear={() => {
        loadMore();
    }}/>
        </View>
      </View>
    </Sensor>;
};
export function _customPVReportParams(params) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
        const custom = {
            tex_id: ((_a = params === null || params === void 0 ? void 0 : params.queryParams) === null || _a === void 0 ? void 0 : _a['pageId']) || '-999',
            hotel_channel: ((_b = params === null || params === void 0 ? void 0 : params.queryParams) === null || _b === void 0 ? void 0 : _b['hotelchannel']) || '-999'
        };
        if ((_c = window === null || window === void 0 ? void 0 : window.location) === null || _c === void 0 ? void 0 : _c.href) {
            custom.url = window.location.href;
        }
        return {
            custom: custom
        };
    });
}
export default memo(PhxPoiList);
